import React from 'react';
import { HiMiniUsers } from 'react-icons/hi2';
import { ImTree } from 'react-icons/im';

const CourseCard = ({ currentCard, setCurrentCard, cardData }) => {
    const cardClickHandler = (value) => {
        setCurrentCard(value);
    }

    return (
        <div className='w-[360px] lg:w-[30%]'>
            <div
                onClick={() => cardClickHandler(cardData.heading)}
                className={`h-[20rem] cursor-pointer transition-all duration-200 lg:hover:scale-95 lg:hover:bg-richblack-25 lg:hover:text-richblue-500 
                            ${currentCard === cardData.heading ? 'bg-white text-richblue-500 shadow-[12px_12px_0_0] shadow-yellow-50' : 'text-richblack-5 bg-richblack-800'}`}
            >
                <div className='p-6 h-[16rem] border-b-2 border-dashed border-richblack-300'>
                    <h2 className='text-lg font-bold leading-10 hover:text-richblue-500'>{cardData.heading}</h2>
                    <p className='text-richblack-300 text-md'>{cardData.description}</p>
                </div>
                <div className='flex justify-between text-blue-300 items-center p-5'>
                    <div className='flex gap-2 justify-center items-center text-[16px]'>
                        <HiMiniUsers />
                        <span>
                            {cardData.level}
                        </span>
                    </div>
                    <div className='flex justify-center items-center'>
                        <ImTree />
                        <span className='mx-2'>
                            {cardData.lessionNumber} Lesson
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CourseCard;